const locales = {
    zh_hant: {
        title: '系統問題回報',
        description: '您好，如果在系統使用上遇到問題，請提供您的稱呼、聯繫方式與問題敘述，我們會儘速進行處理，並透過您留言的信箱與您聯繫。若是對展覽與競賽的資訊問題，則建議您透過服務小組信箱洽詢主辦單位。感謝您的參與與協助！',
        nameLabel: '姓名',
        namePlaceholder: '姓名或暱稱',
        emailLabel: '電子信箱',
        emailPlaceholder: '請填寫 Email',
        messageLabel: '問題敘述',
        messagePlaceholder: '請盡可能明確描述您所遇到的問題，以提供系統小組排錯參考。如果可能，建議您保留您遭遇問題的螢幕截圖，以備後續排錯流程可提供系統小組參考。',
        cancel: '取消',
        submit: '確認並送出',
        successMessage: '問題已成功回報',
    },
    en: {
        title: 'Report an Issue',
        description: 'If you encounter any issues while using the system, please provide your name, contact information, and a description of the problem. Our team will review your report as soon as possible and contact you via the email you provided. For inquiries related to exhibitions or competitions, please reach out to the organizer via the service team email. Thank you for your support and cooperation!',
        nameLabel: 'Name',
        namePlaceholder: 'Name or nickname',
        emailLabel: 'Email',
        emailPlaceholder: 'Enter your email',
        messageLabel: 'Issue Description',
        messagePlaceholder: 'Please describe the issue as clearly as possible to help our technical team investigate. If available, a screenshot of the issue would be helpful.',
        cancel: 'Cancel',
        submit: 'Submit',
        successMessage: 'Issue reported successfully',
    },
}

export default locales
